module.exports = __webpack_public_path__ + "img/atom.42eec6ef.gif";